'use strict';
exports.__esModule = true;
var password_1 = require("../logic/password");
angular.module('smartorg.r6.cmpts.password').directive('passwordKit', [function () {
        return {
            restrict: 'E',
            template: require('../../template/password.html'),
            scope: {
                rule: '@',
                hideCancel: '@?',
                saveFn: '&?',
                cancelFn: '&?',
                pageTitle: '@?'
            },
            link: function (scope) {
                if (!scope.saveFn) {
                    scope.saveFn = function () {
                        alert("System error.");
                    };
                }
                if (!scope.cancelFn) {
                    scope.cancelFn = function () {
                    };
                }
                scope.oldValue = "";
                scope.value = "";
                scope.revalue = "";
                // scope.err = "";
                scope.err = [];
                scope.passwordDescription = "";
                // scope.pageTitle = scope.rule === 'user' ? "Change Password" :
                //     "Set New Password";
                /**
                 * Display text for password strength.
                 */
                scope.lv = ['Weak', 'Fair', 'Good', 'Strong', 'Very Strong',
                    'Very Strong', 'Very Strong',
                    'Armored', 'Bulletproof', 'Nonbreakable', 'Invulnerable',
                    'Everlasting', 'Hi James', 'Call the Avengers',
                    'Maybe the League?', 'I\'m warning you',
                    'Stop right there!', 'System Failed'];
                /**
                 * Raw password strength score without limit.
                 */
                scope.rawScore = 0;
                /**
                 * Score with upper limit 200. This value also use to
                 * set the width of the strength bar, so a limit of
                 * length is required.
                 */
                scope.score = 0;
                /**
                 * Strength level, also use as index to get text from
                 * lv array.
                 */
                scope.strength = 0;
                /**
                 * Calculate score when user type in any password.
                 */
                scope.scorePassword = function () {
                    scope.rawScore = password_1["default"].scorePassword(scope.value);
                    scope.score = Math.min(scope.rawScore, 80) * 1.25;
                    // This line is for fun.
                    scope.strength = Math.floor(scope.rawScore / 20.5);
                    // This line is what it should be.
                    // this.strength = Math.floor(this.score / 52);
                };
                scope.checkRetype = function () {
                    scope.passRetype = scope.revalue === scope.value;
                    if (scope.passRetype) {
                        scope.checkPass();
                    }
                };
                scope.hideButton = true;
                scope.checkPass = function () {
                    var errors = [];
                    password_1["default"].checkers.forEach(function (checker) {
                        if (!checker.check(scope.value)) {
                            errors.push(checker.errorMessage());
                        }
                    });
                    scope.err = errors;
                    if (scope.revalue != "" && errors.length == 0 && scope.passRetype) {
                        scope.hideButton = false;
                    }
                };
                /**
                 * Check and save password.
                 */
                scope.savePassword = function () {
                    // let errors: any = [];
                    // passwordLogic.checkers.forEach(function (checker) {
                    //     if (!checker.check(scope.value)) {
                    //         errors.push(checker.errorMessage());
                    //     }
                    // });
                    scope.err = [];
                    if (!scope.value) {
                        scope.err.push("Please enter a password.");
                    }
                    else if (scope.revalue !== scope.value) {
                        scope.err.push("Please enter a password.");
                    }
                    else {
                        scope.saveFn({
                            oldPsw: scope.oldValue,
                            newPsw: scope.value
                        });
                    }
                };
                /**
                 * Clean up stuff on closing the modal.
                 */
                scope.cleanup = function () {
                    scope.oldValue = "";
                    scope.value = "";
                    scope.revalue = "";
                    // scope.err = "";
                    scope.err = [];
                    scope.rawScore = 0;
                    scope.score = 0;
                    scope.strength = 0;
                };
                /**
                 * Handle the cancel button event.
                 */
                scope.cancel = function () {
                    scope.cleanup();
                    scope.cancelFn();
                };
                scope.passwordDescription = "Passwords must contain at least 8 " +
                    "characters in length, lowercase and uppercase letters, digits, " +
                    "special characters(e.g.@$!%*?&)";
                scope.$on('password:save_feedback', function (event, args) {
                    scope.err = [];
                    if (args.status > 0) {
                        // scope.err = args.message;
                        scope.err.push(args.message);
                    }
                    else {
                        scope.cleanup();
                    }
                    setTimeout(function () {
                        scope.$apply();
                    });
                });
            }
        };
    }]);
module.exports = 'smartorg.r6.cmpts.password';
//# sourceMappingURL=password-directive.js.map


// WEBPACK FOOTER //
// ./app/components/password/app/js/plumbing/password-directive.js